<div class="modal fade" id="lotDetailModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true" style="z-index: 1000000">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title fw-bold"><span jhiTranslate="inventoryManagerApp.lot.detail.header">Lot Details</span>: {{lot?.stockId}} ({{lot?.lotId}})</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clear()"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid pt-2">
                    <ul class="nav nav-tabs">
                        <li class="nav-item pe-1">
                            <a class="nav-link"
                               [routerLink]="[{ outlets: { 'lot-detail-outlet': 'lot-basic-details' }}]" [routerLinkActive]="['active']"
                               queryParamsHandling="merge" jhiTranslate="inventoryManagerApp.lot.detail.title">Lot</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link"
                               [routerLink]="[{ outlets: { 'lot-detail-outlet': 'source' }}]"  [routerLinkActive]="['active']"
                               queryParamsHandling="merge" jhiTranslate="inventoryManagerApp.lot.source.title">Source Lots</a>
                        </li>
                        <li class="nav-item pe-1">
                            <a class="nav-link"
                               [routerLink]="[{ outlets: { 'lot-detail-outlet': 'attributes' }}]"  [routerLinkActive]="['active']"
                               queryParamsHandling="merge" jhiTranslate="inventoryManagerApp.lot.attributes.title">Inventory Attributes</a>
                        </li>
                        <li class="nav-item pe-1" *ngIf="isFileStorageConfigured">
                            <a class="nav-link"
                               [routerLink]="[{ outlets: { 'lot-detail-outlet': 'files' }}]"  [routerLinkActive]="['active']"
                               queryParamsHandling="merge" jhiTranslate="inventoryManagerApp.lot.files.title">Files</a>
                        </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane container-fluid active">
                            <router-outlet name="lot-detail-outlet"></router-outlet>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
                    <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
                </button>
            </div>
        </div>
    </div>
</div>


